<script>
export default {
  name: 'ReportsWrapper',
  computed: {
    containerClasses() {
      // Rotas que adotaram o padrao PageLayout/PageHeader (largura 100%)
      // ou paineis que ja sao full-width (custom reports, round robin).
      const FULL_WIDTH_ROUTES = new Set([
        'custom_reports',
        'round_robin_dashboard',
        'account_overview_reports',
        'account_operations_reports',
        'ad_leads_reports',
        'meta_costs_reports',
        'pause_reports',
        'conversation_reports',
        'sla_reports',
        'bot_reports',
        'csat_reports',
        'agent_reports_index',
        'inbox_reports_index',
        'label_reports_index',
        'team_reports_index',
        // List pages legadas (rota /agent, /inboxes, /label, /teams).
        'agent_reports',
        'inbox_reports',
        'label_reports',
        'team_reports',
        // Show pages com drill-down por id (rota /agents/:id etc).
        'agent_reports_show',
        'inbox_reports_show',
        'label_reports_show',
        'team_reports_show',
      ]);
      // Subconjunto das full-width que rola POR DENTRO (tabela com cabeçalho
      // fixo e paginação à vista): precisa da altura inteira do wrapper — com
      // altura automática o `h-full` da página não vale e a tabela cresce até
      // o fim, levando o cabeçalho junto na rolagem.
      const FULL_HEIGHT_ROUTES = new Set([
        'ad_leads_reports',
        'meta_costs_reports',
        'pause_reports',
      ]);
      if (FULL_WIDTH_ROUTES.has(this.$route.name)) {
        return FULL_HEIGHT_ROUTES.has(this.$route.name)
          ? 'w-full h-full'
          : 'w-full pb-12';
      }
      // Demais rotas mantem max-w-[60rem] (visual antigo).
      return 'max-w-[60rem] mx-auto pb-12';
    },
  },
};
</script>

<template>
  <div class="reports--wrapper overflow-auto bg-n-background w-full">
    <!-- Container com largura dinâmica baseada na rota -->
    <div :class="containerClasses">
      <router-view />
    </div>
  </div>
</template>

<style scoped lang="scss">
.reports--wrapper {
  :deep() {
    .multiselect--disabled {
      @apply opacity-50 border border-n-weak rounded-md cursor-not-allowed;
    }

    .multiselect__content-wrapper {
      @apply bg-n-solid-2 border border-n-weak text-n-slate-12;
    }

    .multiselect__tags {
      @apply bg-n-slate-1 border border-n-weak m-0 min-h-[2.875rem] pt-0;

      input[type='text'] {
        @apply bg-n-alpha-3 border-n-weak placeholder:text-n-slate-11 min-h-[2.375rem] h-[2.375rem] px-0.5 py-0 text-sm;
      }
    }

    .multiselect__placeholder {
      @apply text-n-slate-11;
    }

    .multiselect__select {
      @apply min-h-0;
    }

    .multiselect__single {
      @apply bg-n-alpha-3 text-n-slate-11;
    }

    .multiselect__input {
      @apply text-sm h-[2.375rem] mb-0 py-0;
    }

    .multiselect__tags,
    .multiselect__input,
    .multiselect {
      @apply bg-n-alpha-3 !border-n-weak text-n-slate-12 rounded-lg text-sm min-h-[2.5rem];
    }

    .mx-input-wrapper {
      @apply bg-n-alpha-3 border-n-weak text-n-slate-12 rounded-lg text-sm;

      input {
        @apply border-n-weak text-sm;
      }
    }

    .multiselect__option {
      @apply flex items-center;
    }

    .mx-datepicker {
      .mx-input {
        background-color: transparent !important;
      }

      .mx-input-wrapper input::placeholder {
        @apply text-n-slate-11;
      }

      .mx-input-wrapper input {
        @apply text-n-slate-11;
      }
    }

    .multiselect--active:not(.multiselect--above) .multiselect__current,
    .multiselect--active:not(.multiselect--above) .multiselect__input,
    .multiselect--active:not(.multiselect--above) .multiselect__tags {
      @apply rounded-b-none;
    }
  }
}
</style>
